import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { SEO } from "../../components/SEO";
import { preloadImages } from "../../utils/imagePreload";
import { 
  HomeRoot, 
  ClientsSection, 
  ClientsHeader, 
  ClientsTitle,
  ClientsLogoContainer,
  LogoScrollWrapper,
  LogoItem,
  ServiceSection,
  ServiceHeader,
  ServiceTitle,
  ServiceDescription,
  ServiceContent,
  ServiceTabContent,
  ServiceTabBackground,
  ServiceTabTitle,
  ServiceTabText,
  WorksSection,
  WorksHeader,
  WorksHeaderLeft,
  WorksTitle,
  WorksDescription,
  ViewMoreButton,
  WorksCarousel,
  WorksCard,
  WorksCardImage,
  WorksCardContent,
  WorksCardTitle,
  WorksCardTags,
  WorksCardTag,
  PowerSection,
  PowerHeader,
  PowerTitle,
  PowerDescription,
  PowerContent,
  PowerStatsRow,
  PowerStatCard,
  PowerStatImage,
  PowerStatContent,
  PowerNumber,
  PowerLabel,
  PowerPartnersRow,
  PowerPartnerCard,
  PowerPartnerLogo,
  PowerPartnerLabel,
  TrustSection,
  TrustHeader,
  TrustTitle,
  TrustDescription,
  TrustCarousel,
  TrustCard,
  TrustCardLogo,
  TrustCardQuote,
  TrustCardAuthor,
  BannerContainer,
  BannerTitle,
  MoreButton,
  MoreText,
  SvgWrapper,
  ServiceTabImage,
  ServiceTabTextWrapper,
  ServiceCardSlider,
  ServiceCardContainer,
  PageIndicator,
  IndicatorDot,
  ServiceTabs,
  ServiceTab,
  ServicePCContent,
  CenterContainer,
  ServiceCardInner
} from "./styles";
import PlaceholderLogo from "../../components/PlaceholderLogo";
import { useHeader } from '../../contexts/HeaderContext';
import Link from '../../components/Link/Link';
import { fetchTrusts, TrustTestimonial } from "apis/trust";
import { fetchHomeWorks, WorkSimple } from "apis/works";

// 클라이언트 로고 데이터
const clientLogos = [
  { id: 1, name: "S-OIL", src: "/images/home/client-rolling/S-OIL_LOGO_2.png" },
  { id: 2, name: "혜움", src: "/images/home/client-rolling/혜움_LOGO_2.png" },
  { id: 3, name: "하기스", src: "/images/home/client-rolling/하기스_LOGO_2.png" },
  { id: 4, name: "푸드올로지", src: "/images/home/client-rolling/푸드올로지_LOGO_2.png" },
  { id: 5, name: "파파모빌리티", src: "/images/home/client-rolling/파파모빌리티_LOGO_2.png" },
  { id: 6, name: "틱톡", src: "/images/home/client-rolling/틱톡_LOGO_2.png" },
  { id: 7, name: "코카콜라", src: "/images/home/client-rolling/코카콜라_LOGO_2.png" },
  { id: 8, name: "코오롱 오토모티브", src: "/images/home/client-rolling/코오롱 오토모티브_LOGO_2.png" },
  { id: 9, name: "코닥", src: "/images/home/client-rolling/코닥_LOGO_2.png" },
  { id: 11, name: "유한킴벌리", src: "/images/home/client-rolling/유한킴벌리_LOGO_2.png" },
  { id: 12, name: "식봄", src: "/images/home/client-rolling/식봄_LOGO_2.png" },
  { id: 13, name: "비플레인", src: "/images/home/client-rolling/비플레인_LOGO_2.png" },
  { id: 14, name: "비즈넵", src: "/images/home/client-rolling/비즈넵_LOGO_2.png" },
  { id: 15, name: "버거킹", src: "/images/home/client-rolling/버거킹_LOGO_2.png" },
  { id: 16, name: "바른치킨", src: "/images/home/client-rolling/바른치킨_LOGO_2.png" },
  { id: 17, name: "밀리의 서재", src: "/images/home/client-rolling/밀리의 서재_LOGO_2.png" },
  { id: 18, name: "루킨스", src: "/images/home/client-rolling/루킨스_LOGO_2.png" },
  { id: 19, name: "그린핑거", src: "/images/home/client-rolling/그린핑거_LOGO_2.png" },
  { id: 20, name: "골든블루", src: "/images/home/client-rolling/골든블루_LOGO_2.png" },
];

// 서비스 탭 데이터
const serviceTabs = [
  { 
    id: 'strategy', 
    name: '통합 전략 제안', 
    width: 134,
    title: 'Brand Strategy',
    description: '다양한 성공 경험을 기반으로\n목표 달성을 위한 기획/실행 전략을 제안합니다',
    mobileDescription: '다양한 성공 경험을 기반으로\n목표 달성을 위한\n기획/실행 전략을 제안합니다',
    image: "/images/home/service/brand-strategy.png",
    mobileHide: false
  },
  { 
    id: 'data', 
    name: '데이터 마케팅', 
    width: 129,
    title: 'Growth Marketing',
    description: '데이터 기반의\n브랜드 분석 및 맞춤 전략으로\n성공적인 퍼포먼스를 만듭니다',
    mobileDescription: '데이터 기반의\n브랜드 분석 및 맞춤 전략으로\n성공적인 퍼포먼스를 만듭니다',
    image: "/images/home/service/growth-marketing.png"
  },
  { 
    id: 'viral', 
    name: '바이럴 마케팅', 
    width: 129,
    title: 'UGC Marketing',
    description: '인플루언서 및 체험단 등\n사용자가 직접 생성한 콘텐츠로\n퍼포먼스를 극대화 시킵니다',
    mobileDescription: '인플루언서 및 체험단 등\n사용자가 직접 생성한 콘텐츠로\n퍼포먼스를 극대화 시킵니다',
    image: "/images/home/service/ugc-marketing.png"
  },
  { 
    id: 'content', 
    name: '콘텐츠 제작', 
    width: 109,
    title: 'Creative',
    description: '목적에 맞는 크리에이티브 소재 및\n숏폼 콘텐츠 제작으로\n성과 증대 및 목표달성에 기여합니다',
    mobileDescription: '목적에 맞는 크리에이티브 소재 및\n숏폼 콘텐츠 제작으로\n성과 증대 및 목표달성에 기여합니다',
    image: "/images/home/service/creative.png"
  },
  { 
    id: 'dashboard', 
    name: '대시보드 자동화', 
    width: 150,
    title: 'PUZL Board',
    description: '다양한 매체 데이터를 자동으로 수집하여\n원하는 인사이트만 제공해 드립니다',
    mobileDescription: '다양한 매체 데이터를\n자동으로 수집하여\n원하는 인사이트만 제공해 드립니다',
    image: "/images/home/service/puzl-board.png"
  },
];

interface HomeWorkItem {
  id: number;
  title: string;
  image: string;
  tags: string[];
  url: string;
}

// 숫자 애니메이션을 위한 커스텀 훅
const useNumberAnimation = (targetValue: number, duration: number = 2000) => {
  const [displayValue, setDisplayValue] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    let startTime: number | null = null;
    let animationFrameId: number;

    const animateNumber = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = Math.floor(progress * targetValue);
      
      setDisplayValue(currentValue);

      if (progress < 1) {
        animationFrameId = requestAnimationFrame(animateNumber);
      } else {
        setDisplayValue(targetValue);
      }
    };

    animationFrameId = requestAnimationFrame(animateNumber);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [targetValue, duration, isVisible]);

  // 천 단위 콤마 포맷팅
  const formattedValue = displayValue.toLocaleString();

  return { value: formattedValue, ref };
};

// Power 섹션 데이터 수정 - 각 카드별 이미지 크기 지정
const powerStats = [
  {
    id: 1,
    number: 270,
    label: "프로젝트 수",
    bgColor: "linear-gradient(136deg, #00C8CA 0%, #0DADB6 100%)",
    image: "/images/home/power/docs.png",
    imageWidth: 354,
    imageHeight: 354
  },
  {
    id: 2,
    number: 40,
    label: "공식 및 제휴 매체 수",
    bgColor: "linear-gradient(134deg, #488AFD 0%, #3C6CE9 100%)",
    image: "/images/home/power/sound.png",
    imageWidth: 325,
    imageHeight: 325
  },
  {
    id: 3,
    number: 30,
    label: "전문가 수",
    bgColor: "linear-gradient(134deg, #FFD761 0%, #FFAB13 100%)",
    image: "/images/home/power/person.png",
    imageWidth: 349,
    imageHeight: 349
  },
  {
    id: 4,
    number: 300,
    label: "누적 취급액",
    bgColor: "linear-gradient(133deg, #F97978 0%, #FF3D43 100%)",
    image: "/images/home/power/money.png",
    imageWidth: 373,
    imageHeight: 373
  }
];

// Power 파트너 데이터 수정
const powerPartners = [
  {
    id: 1,
    logo: "/images/home/power/google-partners.png",
    mobileLogo: "/images/home/power/google-partners-mo.png", // 모바일용 이미지 추가
    label: "구글 프리미어파트너"
  },
  {
    id: 2,
    logo: "/images/home/power/meta.png",
    label: "메타 비즈니스파트너"
  },
  {
    id: 3,
    logo: "/images/home/power/toss-ads.png",
    label: "토스애즈 공식대행사"
  }
];

const Home = () => {
  const { setIsTransparent } = useHeader();
  const navigate = useNavigate();
  const [trustTestimonials, setTrustTestimonials] = useState<TrustTestimonial[]>([]);
  const [homeWorksData, setHomeWorksData] = useState<HomeWorkItem[]>([]);

  // Trust 섹션 데이터
  useEffect(() => {
    const loadTrusts = async () => {
      const trusts = await fetchTrusts();
      setTrustTestimonials(trusts);
    };
    loadTrusts();
  }, []);

  useEffect(() => {
    const loadWorks = async () => {
      try {
        const works = await fetchHomeWorks();
        console.log('Fetched works data:', works); // 디버깅용
        const mappedWorks = works.map(work => ({
          id: work.id,
          title: work.title,
          image: work.thumbnailUrl,
          tags: [`#${work.workScope}`, `#${work.industry}`],
          url: work.slug ? `/works/${work.slug}` : `/works/${work.id}` // slug가 없으면 id 사용
        }));
        console.log('Mapped works data:', mappedWorks); // 디버깅용
        setHomeWorksData(mappedWorks);
      } catch (error) {
        console.error('Failed to fetch works:', error);
      }
    };
    loadWorks();
  }, []);

  const [activeTab, setActiveTab] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isAnimating, setIsAnimating] = useState(false); 
  const [prevTab, setPrevTab] = useState(0);
  const [direction, setDirection] = useState<string>('right');
  
  // Add refs and state for works carousel scrolling
  const worksCarouselRef = useRef<HTMLDivElement>(null);
  const [isWorksScrolling, setIsWorksScrolling] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [wasScrolling, setWasScrolling] = useState(false);
  const [scrollDistance, setScrollDistance] = useState(0);
  
  // Add this ref to track if we're currently repositioning the scroll
  const isRepositioningRef = useRef(false);
  // Add ref for auto-scroll animation
  const autoScrollIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const autoScrollSpeedRef = useRef(0.9); // 스크롤 속도 증가
  
  // Add refs and state for trust carousel scrolling
  const trustCarouselRef = useRef<HTMLDivElement>(null);
  const [isTrustScrolling, setIsTrustScrolling] = useState(false);
  const [trustStartX, setTrustStartX] = useState(0);
  const [trustScrollLeft, setTrustScrollLeft] = useState(0);
  const trustAutoScrollIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const trustAutoScrollSpeedRef = useRef(1.1); // 스크롤 속도 더 증가
  const isTrustRepositioningRef = useRef(false);
  const [isTrustAutoScrollPaused, setIsTrustAutoScrollPaused] = useState(false);
  
  // 클라이언트 로고 롤링을 위한 refs 추가
  const clientLogoContainerRef = useRef<HTMLDivElement>(null);
  const clientLogoWrapperRef = useRef<HTMLDivElement>(null);
  const clientLogoScrollIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const isClientLogoRepositioningRef = useRef(false);
  
  const isMobile = windowWidth <= 768;
  // Section refs
  const bannerRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  // 프리로딩 상태를 추적하기 위한 state
  const [preloadedIds, setPreloadedIds] = useState<Set<number>>(new Set());

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // 클라이언트 로고 롤링을 위한 함수 추가
  const startClientLogoScroll = () => {
    if (clientLogoScrollIntervalRef.current) {
      clearInterval(clientLogoScrollIntervalRef.current);
    }
    
    const speed = isMobile ? 1.0 : 1.5; // 속도 증가: 0.5 → 1.0, 0.8 → 1.5
    
    clientLogoScrollIntervalRef.current = setInterval(() => {
      if (clientLogoContainerRef.current && clientLogoWrapperRef.current && !isClientLogoRepositioningRef.current) {
        const container = clientLogoContainerRef.current;
        const wrapper = clientLogoWrapperRef.current;
        
        // 로고 아이템 하나의 너비 + 간격 계산
        const logoItems = wrapper.querySelectorAll('.logo-item');
        if (logoItems.length === 0) return;
        
        // 스크롤 위치 증가
        wrapper.style.transform = `translateX(${parseFloat(wrapper.style.transform?.split('translateX(')[1] || '0') - speed}px)`;
        
        // 첫 번째 로고 아이템의 너비 + 간격 구하기
        const firstItem = logoItems[0] as HTMLElement;
        const itemWidth = firstItem.offsetWidth;
        const itemMargin = parseInt(window.getComputedStyle(firstItem).marginRight);
        const totalItemWidth = itemWidth + (isMobile ? 30 : 56); // gap 값 (styles.tsx에서 설정된 값)
        
        // 현재 transform 값 가져오기
        const currentTransform = parseFloat(wrapper.style.transform?.split('translateX(')[1] || '0');
        
        // 첫 번째 아이템이 컨테이너를 벗어났을 때
        if (Math.abs(currentTransform) >= totalItemWidth) {
          isClientLogoRepositioningRef.current = true;
          
          // 첫 번째 아이템을 맨 뒤로 이동
          const firstItem = logoItems[0];
          wrapper.appendChild(firstItem);
          
          // transform 값 재설정 (첫 번째 아이템 너비만큼 조정)
          wrapper.style.transform = `translateX(${currentTransform + totalItemWidth}px)`;
          
          // 재배치 완료
          isClientLogoRepositioningRef.current = false;
        }
      }
    }, 16); // 약 60fps
  };
  
  // 클라이언트 로고 롤링 초기화
  useEffect(() => {
    if (clientLogoWrapperRef.current) {
      // 초기 위치 설정
      clientLogoWrapperRef.current.style.transform = 'translateX(0)';
      
      // 롤링 시작
      startClientLogoScroll();
    }
    
    return () => {
      if (clientLogoScrollIntervalRef.current) {
        clearInterval(clientLogoScrollIntervalRef.current);
      }
    };
  }, [isMobile]);

  // Add effect to auto-play video
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.autoplay = true;
      videoRef.current.loop = true;
      videoRef.current.playsInline = true;
      
      // Try to play the video
      const playPromise = videoRef.current.play();
      
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.error("Auto-play was prevented:", error);
          // Show play button or handle the error
        });
      }
    }
  }, []);

  // 모바일에서 서비스 탭 슬라이드 처리
  const serviceTabsRef = useRef<HTMLDivElement>(null);

  // 필터링된 탭 데이터
  const filteredTabs = useMemo(() => {
    return serviceTabs.filter(tab => !isMobile || !tab.mobileHide);
  }, [isMobile]);

  // activeTab 초기값 설정 수정
  useEffect(() => {
    if (isMobile && activeTab === 0) {
      // 모바일에서는 filteredTabs의 첫 번째 항목(인덱스 0)으로 설정
      setActiveTab(0);
    }
  }, [isMobile, activeTab]);

  const handleTabScroll = (index: number) => {
    if (windowWidth <= 1024 && serviceTabsRef.current) {
      const tabElement = serviceTabsRef.current.children[index] as HTMLElement;
      const scrollLeft = tabElement.offsetLeft - 20;
      serviceTabsRef.current.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }
  };

  const handleTabClick = (index: number) => {
    if (activeTab !== index) {
      setDirection(index > activeTab ? 'right' : 'left');
      setPrevTab(activeTab);
      setActiveTab(index);
      setIsAnimating(true);
      
      setTimeout(() => {
        setIsAnimating(false);
      }, 500);

      if (windowWidth <= 768 && serviceCardContainerRef.current) {
        const container = serviceCardContainerRef.current;
        const cardWidth = container.offsetWidth; // 현재 컨테이너의 실제 너비 사용
        const scrollPosition = index * cardWidth;
        
        container.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      } else {
        handleTabScroll(index);
      }
      
      const activeElement = document.activeElement as HTMLElement;
      if (activeElement) {
        activeElement.blur();
      }
    }
  };
  // 카드 클릭 핸들러 추가
  const handleCardClick = (url: string) => {
    console.log('Card clicked with URL:', url); // 디버깅용
    console.log('wasScrolling:', wasScrolling, 'scrollDistance:', scrollDistance); // 디버깅용
    
    // Only navigate if we weren't scrolling and URL is valid
    if (!wasScrolling && scrollDistance < 10 && url) {
      console.log('Navigating to:', url); // 디버깅용
      navigate(url);
    } else {
      console.log('Navigation blocked - wasScrolling:', wasScrolling, 'scrollDistance:', scrollDistance, 'url:', url); // 디버깅용
    }
  };

  useEffect(() => {
    setIsTransparent(true);
    return () => {
      setIsTransparent(false);
    };
  }, [setIsTransparent]);

  // Add this effect to handle scrolling events for the header
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 50) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    // Create the intersection observer with a much larger rootMargin
    // This helps prevent scroll jank by having animations complete well before scrolling to them
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -10% 0px', // Less negative rootMargin to start animations earlier
      threshold: 0 // Trigger as soon as any part of the element is visible
    };

    // Use requestAnimationFrame to apply classList changes to avoid layout thrashing
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Delay applying the visible class to the next frame to avoid jank
          requestAnimationFrame(() => {
            entry.target.classList.add('visible');
          });
        }
      });
    }, observerOptions);

    // Observe all sections at once
    document.querySelectorAll('section').forEach(section => {
      observer.observe(section);
    });

    document.querySelectorAll('.fade-in-section').forEach(element => {
      observer.observe(element);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  // Add this special useEffect for iOS scrolling
  useEffect(() => {
    // iOS scrolling fix with minimal body style impact
    document.documentElement.style.overflowX = 'hidden';
    document.documentElement.style.overflowY = 'auto';
    document.documentElement.style.height = '100%';
    
    // Use cssText for body styles to include webkit properties
    document.body.style.cssText = `
      overflow-x: hidden;
      overflow-y: auto;
      height: auto;
      -webkit-overflow-scrolling: touch;
    `;
    
    // Add low-impact touch handlers
    document.addEventListener('touchstart', () => {}, { passive: true });
    document.addEventListener('touchmove', () => {}, { passive: true });
    
    return () => {
      document.removeEventListener('touchstart', () => {});
      document.removeEventListener('touchmove', () => {});
    };
  }, []);
  
  const handleTouchEnd = () => {
    // Empty handler - browser handles scrolling
  };

  // 컨테이너 ref 추가
  const serviceCardContainerRef = useRef<HTMLDivElement>(null);

  // 스크롤 이벤트 리스너 수정
  useEffect(() => {
    if (!serviceCardContainerRef.current) return;
    
    const container = serviceCardContainerRef.current;
    let scrollTimeout: NodeJS.Timeout | null = null;
    let isScrolling = false;
    
    const handleServiceScroll = () => {
      if (!container) return;
      
      if (!isScrolling) {
        isScrolling = true;
      }
      
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
        const scrollPosition = container.scrollLeft;
        const cardWidth = container.offsetWidth; // 현재 컨테이너의 실제 너비 사용
        
        const newActiveTab = Math.round(scrollPosition / cardWidth);
        
        if (newActiveTab >= 0 && newActiveTab < filteredTabs.length && newActiveTab !== activeTab) {
          setActiveTab(newActiveTab);
        }
      }, 100);
    };
    
    container.addEventListener('scroll', handleServiceScroll);
    
    if (isMobile && container.scrollLeft === 0) {
      setTimeout(() => {
        setActiveTab(0);
      }, 100);
    }
    
    return () => {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      container.removeEventListener('scroll', handleServiceScroll);
    };
  }, [activeTab, filteredTabs.length, isMobile]);

  // useEffect to make sure first card is visible on mount
  useEffect(() => {
    // 확실히 첫 번째 카드가 보이도록 설정
    if (serviceCardContainerRef.current) {
      // 컴포넌트 마운트 시 스크롤 위치 0으로 초기화
      serviceCardContainerRef.current.scrollLeft = 0;
      setActiveTab(0);
    }
  }, []);

  // Add function to handle automatic scrolling
  const startAutoScroll = () => {
    if (autoScrollIntervalRef.current) {
      clearInterval(autoScrollIntervalRef.current);
    }
    
    autoScrollIntervalRef.current = setInterval(() => {
      if (worksCarouselRef.current && !isWorksScrolling && !isRepositioningRef.current) {
        worksCarouselRef.current.scrollLeft += 1.1; // Trust와 동일한 속도로 조정
        handleInfiniteScroll();
      }
    }, 16);
    
    // 작은 스크롤을 강제로 발생시켜 작동 확인
    if (worksCarouselRef.current) {
      worksCarouselRef.current.scrollLeft += 1;
    }
  };
  
  // Stop auto-scroll when user interacts
  const stopAutoScroll = () => {
    if (autoScrollIntervalRef.current) {
      clearInterval(autoScrollIntervalRef.current);
      autoScrollIntervalRef.current = null;
    }
  };
  
  // Resume auto-scroll after user interaction
  const resumeAutoScroll = () => {
    setTimeout(() => {
      if (!isWorksScrolling) {
        startAutoScroll();
      }
    }, 500); // Resume after 0.5 seconds of inactivity
  };

  // Add a function to handle infinite scroll for the works carousel
  const handleInfiniteScroll = () => {
    if (!worksCarouselRef.current || isRepositioningRef.current) return;
    
    const container = worksCarouselRef.current;
    const containerWidth = container.clientWidth;
    const scrollWidth = container.scrollWidth;
    const scrollPosition = container.scrollLeft;
    
    // Calculate the threshold positions (20% from either edge)
    const leftThreshold = scrollWidth * 0.2;
    const rightThreshold = scrollWidth * 0.8;
    
    // If we're near the left edge, jump to the right section
    if (scrollPosition < leftThreshold) {
      isRepositioningRef.current = true;
      // Jump to the middle-right section (skip one full set)
      const jumpPosition = scrollPosition + (homeWorksData.length * (windowWidth <= 1024 ? 263 : 430));
      
      // Use setTimeout to avoid layout thrashing
      setTimeout(() => {
        container.scrollLeft = jumpPosition;
        isRepositioningRef.current = false;
      }, 10);
    }
    // If we're near the right edge, jump to the left section
    else if (scrollPosition > rightThreshold) {
      isRepositioningRef.current = true;
      // Jump to the middle-left section (skip one full set)
      const jumpPosition = scrollPosition - (homeWorksData.length * (windowWidth <= 1024 ? 263 : 430));
      
      // Use setTimeout to avoid layout thrashing
      setTimeout(() => {
        container.scrollLeft = jumpPosition;
        isRepositioningRef.current = false;
      }, 10);
    }
  };

  // Add these mouse and touch event handlers for works carousel
  const handleWorksMouseDown = (e: React.MouseEvent) => {
    if (!worksCarouselRef.current) return;
    e.preventDefault(); // Prevent default browser behavior
    setIsWorksScrolling(true);
    setWasScrolling(false);
    setScrollDistance(0);
    setStartX(e.pageX - worksCarouselRef.current.offsetLeft);
    setScrollLeft(worksCarouselRef.current.scrollLeft);
    // Stop auto-scroll when user interacts
    stopAutoScroll();
  };

  const handleWorksMouseMove = (e: React.MouseEvent) => {
    if (!isWorksScrolling || !worksCarouselRef.current) return;
    e.preventDefault(); // Prevent default browser behavior
    const x = e.pageX - worksCarouselRef.current.offsetLeft;
    const walk = (x - startX) * 1.2; // 거의 1:1 매핑 (사용자 드래그 그대로 반영)
    
    // Track scroll distance to determine if this was a click or drag
    const currentScrollDistance = Math.abs(walk);
    if (currentScrollDistance > 5) { // Threshold to consider it a scroll vs click
      setWasScrolling(true);
      setScrollDistance(currentScrollDistance);
    }
    
    // 스크롤 위치 직접 설정 (제약 없이)
    worksCarouselRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleWorksMouseUp = (e: React.MouseEvent) => {
    e.preventDefault(); // Prevent default browser behavior
    setIsWorksScrolling(false);
    // Check for infinite scroll
    handleInfiniteScroll();
    // Resume auto-scroll after user interaction
    resumeAutoScroll();
  };

  const handleWorksTouchStart = (e: React.TouchEvent) => {
    if (!worksCarouselRef.current) return;
    setIsWorksScrolling(true);
    setStartX(e.touches[0].pageX - worksCarouselRef.current.offsetLeft);
    setScrollLeft(worksCarouselRef.current.scrollLeft);
    stopAutoScroll();
  };

  const handleWorksTouchMove = (e: React.TouchEvent) => {
    if (!isWorksScrolling || !worksCarouselRef.current) return;
    const x = e.touches[0].pageX - worksCarouselRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    worksCarouselRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleWorksTouchEnd = () => {
    setIsWorksScrolling(false);
    handleInfiniteScroll();
    startAutoScroll();
  };

  // Add a function to prevent image dragging
  const preventDragHandler = (e: React.DragEvent) => {
    e.preventDefault();
    return false;
  };
  
  // Add an effect to initialize the scroll position to the middle set
  useEffect(() => {
    if (worksCarouselRef.current) {
      // Start in the middle of the carousel for better bidirectional scrolling
      // Wait for the carousel to be fully rendered
      setTimeout(() => {
        if (worksCarouselRef.current) {
          // Calculate the position to show the second set of items
          const initialScrollPosition = homeWorksData.length * (windowWidth <= 1024 ? 247 : 400);
          worksCarouselRef.current.scrollLeft = initialScrollPosition;
          
          // Start auto-scrolling after initialization
          startAutoScroll();
        }
      }, 100);
    }
    
    // Clean up auto-scroll interval on unmount
    return () => {
      if (autoScrollIntervalRef.current) {
        clearInterval(autoScrollIntervalRef.current);
      }
    };
  }, [windowWidth, homeWorksData.length]);

  // Add function to handle automatic scrolling for trust section
  const startTrustAutoScroll = () => {
    if (trustAutoScrollIntervalRef.current) {
      clearInterval(trustAutoScrollIntervalRef.current);
    }
    
    trustAutoScrollIntervalRef.current = setInterval(() => {
      if (trustCarouselRef.current && !isTrustScrolling && !isTrustRepositioningRef.current) {
        trustCarouselRef.current.scrollLeft += trustAutoScrollSpeedRef.current;
        // Check if we need to handle infinite scroll for trust carousel
        handleTrustInfiniteScroll();
      }
    }, 16); // ~60fps
    
    // Force a small scroll to ensure it's working
    if (trustCarouselRef.current) {
      trustCarouselRef.current.scrollLeft += 1;
    }
  };
  
  // Stop trust auto-scroll when user interacts
  const stopTrustAutoScroll = () => {
    if (trustAutoScrollIntervalRef.current) {
      clearInterval(trustAutoScrollIntervalRef.current);
    }
  };
  
  // Resume trust auto-scroll after user interaction
  const resumeTrustAutoScroll = () => {
    setTimeout(() => {
      if (!isTrustScrolling) {
        startTrustAutoScroll();
      }
    }, 500); // Resume after 0.5 seconds of inactivity
  };

  // Add a function to handle infinite scroll for the trust carousel
  const handleTrustInfiniteScroll = () => {
    if (!trustCarouselRef.current || isTrustRepositioningRef.current) return;
    
    const container = trustCarouselRef.current;
    const scrollWidth = container.scrollWidth;
    const scrollPosition = container.scrollLeft;
    
    // Calculate the threshold positions (20% from either edge)
    const leftThreshold = scrollWidth * 0.2;
    const rightThreshold = scrollWidth * 0.8;
    
    // If we're near the left edge, jump to the right section
    if (scrollPosition < leftThreshold) {
      isTrustRepositioningRef.current = true;
      // Jump to the middle-right section (skip one full set)
      const jumpPosition = scrollPosition + (trustTestimonials.length * (windowWidth <= 1024 ? 320 : 492));
      
      // Use setTimeout to avoid layout thrashing
      setTimeout(() => {
        container.scrollLeft = jumpPosition;
        isTrustRepositioningRef.current = false;
      }, 10);
    }
    // If we're near the right edge, jump to the left section
    else if (scrollPosition > rightThreshold) {
      isTrustRepositioningRef.current = true;
      // Jump to the middle-left section (skip one full set)
      const jumpPosition = scrollPosition - (trustTestimonials.length * (windowWidth <= 1024 ? 320 : 492));
      
      // Use setTimeout to avoid layout thrashing
      setTimeout(() => {
        container.scrollLeft = jumpPosition;
        isTrustRepositioningRef.current = false;
      }, 10);
    }
  };

  // Add these mouse and touch event handlers for trust carousel
  const handleTrustMouseDown = (e: React.MouseEvent) => {
    if (!trustCarouselRef.current) return;
    e.preventDefault(); // Prevent default browser behavior
    setIsTrustScrolling(true);
    setTrustStartX(e.pageX - trustCarouselRef.current.offsetLeft);
    setTrustScrollLeft(trustCarouselRef.current.scrollLeft);
    // Stop auto-scroll when user interacts
    stopTrustAutoScroll();
  };

  const handleTrustMouseMove = (e: React.MouseEvent) => {
    if (!isTrustScrolling || !trustCarouselRef.current) return;
    e.preventDefault(); // Prevent default browser behavior
    const x = e.pageX - trustCarouselRef.current.offsetLeft;
    const walk = (x - trustStartX) * 1.2; // 거의 1:1 매핑 (사용자 드래그 그대로 반영)
    
    // 스크롤 위치 직접 설정 (제약 없이)
    trustCarouselRef.current.scrollLeft = trustScrollLeft - walk;
  };

  const handleTrustMouseUp = () => {
    setIsTrustScrolling(false);
    // Check for infinite scroll
    handleTrustInfiniteScroll();
    // Resume auto-scroll after user interaction
    resumeTrustAutoScroll();
  };

  const handleTrustTouchStart = (e: React.TouchEvent) => {
    if (!trustCarouselRef.current) return;
    // 터치 이벤트 시작 시 스크롤링 상태를 false로 설정 (클릭 vs 스크롤 구분을 위해)
    setWasScrolling(false);
    setScrollDistance(0);
    setIsTrustScrolling(true);
    setTrustStartX(e.touches[0].pageX - trustCarouselRef.current.offsetLeft);
    setTrustScrollLeft(trustCarouselRef.current.scrollLeft);
    // Stop auto-scroll when user interacts
    stopTrustAutoScroll();
  };

  const handleTrustTouchMove = (e: React.TouchEvent) => {
    if (!isTrustScrolling || !trustCarouselRef.current) return;
    const x = e.touches[0].pageX - trustCarouselRef.current.offsetLeft;
    const walk = (x - trustStartX) * 1.2; // 거의 1:1 매핑 (사용자 드래그 그대로 반영)
    
    // 스크롤 거리 추적 (클릭 vs 스크롤 구분을 위해)
    const currentScrollDistance = Math.abs(walk);
    if (currentScrollDistance > 5) { // 5px 이상 움직였을 때 스크롤로 간주
      setWasScrolling(true);
      setScrollDistance(currentScrollDistance);
    }
    
    // 스크롤 위치 직접 설정 (제약 없이)
    trustCarouselRef.current.scrollLeft = trustScrollLeft - walk;
  };

  const handleTrustTouchEnd = () => {
    setIsTrustScrolling(false);
    // Check for infinite scroll
    handleTrustInfiniteScroll();
    // Resume auto-scroll after user interaction
    // 단순 클릭이었다면 자동 스크롤 재개하지 않음
    if (wasScrolling) {
      resumeTrustAutoScroll();
    }
  };

  // Add an effect to initialize the scroll position of trust carousel
  useEffect(() => {
    if (trustCarouselRef.current) {
      // Start in the middle of the carousel for better bidirectional scrolling
      // Wait for the carousel to be fully rendered
      setTimeout(() => {
        if (trustCarouselRef.current) {
          // Calculate the position to show the second set of items
          const initialScrollPosition = trustTestimonials.length * (windowWidth <= 1024 ? 320 : 492);
          trustCarouselRef.current.scrollLeft = initialScrollPosition;
          
          // Start auto-scrolling after initialization
          startTrustAutoScroll();
        }
      }, 100);
    }
    
    // Clean up auto-scroll interval on unmount
    return () => {
      if (trustAutoScrollIntervalRef.current) {
        clearInterval(trustAutoScrollIntervalRef.current);
      }
    };
  }, [windowWidth, trustTestimonials.length]);
  
  // Trust 카드 클릭 핸들러 추가
  const handleTrustCardClick = () => {
    // 스크롤 중이 아니었을 때만 클릭 이벤트로 처리
    if (!wasScrolling && scrollDistance < 10) {
      // 자동 스크롤 토글 (멈춤/재개)
      if (isTrustAutoScrollPaused) {
        startTrustAutoScroll();
        setIsTrustAutoScrollPaused(false);
      } else {
        stopTrustAutoScroll();
        setIsTrustAutoScrollPaused(true);
      }
    }
  };
  
  // Add a separate effect with an IntersectionObserver to ensure the Trust section
  // starts scrolling when it becomes visible in the viewport
  useEffect(() => {
    const trustSectionRef = document.querySelector('.trust-section');
    
    if (trustSectionRef) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Restart auto-scrolling when the section becomes visible
              startTrustAutoScroll();
              // No need to keep observing after it starts
              observer.disconnect();
            }
          });
        },
        { threshold: 0.2 } // Start when 20% of the section is visible
      );
      
      observer.observe(trustSectionRef);
      
      return () => {
        observer.disconnect();
      };
    }
    
    // Return empty function to satisfy TypeScript
    return () => {};
  }, [startTrustAutoScroll]);

  // Add a separate effect with an IntersectionObserver to ensure the Works section
  // starts scrolling when it becomes visible in the viewport
  useEffect(() => {
    const worksSectionRef = document.querySelector('.works-carousel');
    
    if (worksSectionRef) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Restart auto-scrolling when the section becomes visible
              startAutoScroll();
              // No need to keep observing after it starts
              observer.disconnect();
            }
          });
        },
        { threshold: 0.2 } // Start when 20% of the section is visible
      );
      
      observer.observe(worksSectionRef);
      
      return () => {
        observer.disconnect();
      };
    }
    
    // Return empty function to satisfy TypeScript
    return () => {};
  }, [startAutoScroll]);

  // 이미지 프리로딩 핸들러
  const handleWorksCardHover = async (work: any) => {
    // 모바일에서는 프리로딩 하지 않음
    if (windowWidth <= 1024 || preloadedIds.has(work.id)) return;

    try {
      const imagesToPreload = [work.image];
      await preloadImages(imagesToPreload);
      setPreloadedIds(prev => new Set([...prev, work.id]));
    } catch (error) {
      console.error('Failed to preload images:', error);
    }
  };

  return (
    <HomeRoot>
      <SEO 
        title="PUZL 퍼즐코퍼레이션 | 성과중심 퍼포먼스·UGC·콘텐츠 풀퍼널 마케팅"
        description="퍼즐코퍼레이션은 브랜드의 성장을 위한 최적의 풀퍼널 마케팅 전략을 제안합니다. 퍼포먼스 광고, UGC 콘텐츠 제작, 미디어 플래닝 등 맞춤형 전략으로 지속가능한 성과를 달성하세요."
        keywords="퍼즐코퍼레이션, PUZL, 풀퍼널마케팅, 디지털마케팅, IT솔루션, 그로스마케팅, 퍼포먼스마케팅"
        ogTitle="PUZL 퍼즐코퍼레이션 | 성과중심 퍼포먼스·UGC·콘텐츠 풀퍼널 마케팅"
        ogDescription="퍼즐코퍼레이션은 브랜드의 성장을 위한 최적의 풀퍼널 마케팅 전략을 제안합니다. 퍼포먼스 광고, UGC 콘텐츠 제작, 미디어 플래닝 등 맞춤형 전략으로 지속가능한 성과를 달성하세요."
        ogImage="/images/og-image2.png"
        twitterTitle="PUZL 퍼즐코퍼레이션 | 성과중심 퍼포먼스·UGC·콘텐츠 풀퍼널 마케팅"
        twitterDescription="퍼즐코퍼레이션은 브랜드의 성장을 위한 최적의 풀퍼널 마케팅 전략을 제안합니다. 퍼포먼스 광고, UGC 콘텐츠 제작, 미디어 플래닝 등 맞춤형 전략으로 지속가능한 성과를 달성하세요."
        twitterImage="/images/og-image2.png"
      />
      <BannerContainer ref={bannerRef}>
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0
          }}
        >
          <source src="/images/home/banner.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div>
          <BannerTitle>
            Hello, Brand!
            <br />
            Let&apos;s Piece Things
            <br />
            All Together
          </BannerTitle>
          <MoreButton>
            <Link to="/works" style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', color: 'white', textDecoration: 'none' }}>
              <MoreText>More</MoreText>
              <SvgWrapper>
                <svg
                  width="22"
                  height="41"
                  viewBox="0 0 22 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 29.1211L11 37.9996L20 29.1211"
                    stroke="white"
                    strokeWidth="3"
                  />
                  <path d="M11 38V0" stroke="white" strokeWidth="3" />
                </svg>
              </SvgWrapper>
            </Link>
          </MoreButton>
        </div>
      </BannerContainer>
      
      <ClientsSection className="fade-in-section">
        <ClientsHeader>
          <ClientsTitle>
            <div>Clients</div>
          </ClientsTitle>
          <ClientsLogoContainer ref={clientLogoContainerRef} tabIndex={-1}>
            <LogoScrollWrapper ref={clientLogoWrapperRef} className="no-animation">
              {clientLogos.map((logo) => (
                <LogoItem 
                  key={`original-${logo.id}`}
                  data-logo={logo.name}
                  className="logo-item"
                >
                  {logo.src ? (
                    <img src={logo.src} alt={logo.name} loading="lazy" />
                  ) : (
                    <PlaceholderLogo name={logo.name} />
                  )}
                </LogoItem>
              ))}
              {clientLogos.map((logo) => (
                <LogoItem 
                  key={`duplicate-${logo.id}`}
                  data-logo={logo.name}
                  className="logo-item"
                >
                  {logo.src ? (
                    <img src={logo.src} alt={logo.name} loading="lazy" />
                  ) : (
                    <PlaceholderLogo name={logo.name} />
                  )}
                </LogoItem>
              ))}
            </LogoScrollWrapper>
          </ClientsLogoContainer>
        </ClientsHeader>
      </ClientsSection>
      
      <CenterContainer>
        <ServiceSection>
          <ServiceHeader>
            <ServiceTitle>Service</ServiceTitle>
            <ServiceDescription>
              퍼즐코퍼레이션은 클라이언트의 매출 성장을 위한{'\n'}풀퍼널 마케팅을 제공합니다.
            </ServiceDescription>
          </ServiceHeader>
          <ServiceContent>
            <ServicePCContent>
              <ServiceTabs ref={serviceTabsRef}>
                {serviceTabs.map((tab, index) => (
                  <ServiceTab
                    key={tab.id}
                    active={activeTab === index}
                    width={tab.width}
                    onClick={() => handleTabClick(index)}
                  >
                    <div>{tab.name}</div>
                  </ServiceTab>
                ))}
              </ServiceTabs>
              <div style={{ position: 'relative', width: '100%', marginTop: '33px' }}>
                {serviceTabs.map((tab, index) => (
                  <ServiceTabContent
                    key={tab.id}
                    active={activeTab === index}
                    direction={direction}
                    style={{ 
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      display: activeTab === index || (isAnimating && prevTab === index) ? 'flex' : 'none'
                    }}
                  >
                    <ServiceTabBackground>
                      <ServiceTabTitle>{tab.title}</ServiceTabTitle>
                      <ServiceTabText>
                        {tab.id === 'dashboard' && windowWidth <= 1260 ? tab.mobileDescription : tab.description}
                      </ServiceTabText>
                    </ServiceTabBackground>
                    <ServiceTabImage>
                      <img 
                        src={tab.image} 
                        alt={tab.title} 
                        style={{ 
                          width: '100%', 
                          height: '100%', 
                          objectFit: 'contain',
                          display: 'block'
                        }} 
                      />
                    </ServiceTabImage>
                  </ServiceTabContent>
                ))}
              </div>
            </ServicePCContent>

            <ServiceCardSlider>
              <ServiceCardContainer
                ref={serviceCardContainerRef}
                onTouchEnd={handleTouchEnd}
              >
                {filteredTabs.map((tab, index) => (
                  <ServiceTabContent
                    key={tab.id}
                    active={activeTab === index}
                  >
                    <ServiceCardInner>
                      <ServiceTabBackground>
                        <ServiceTabImage>
                          <img 
                            src={tab.image} 
                            alt={tab.title} 
                            style={{ 
                              width: '100%', 
                              height: '100%', 
                              objectFit: 'contain',
                              display: 'block'
                            }} 
                          />
                        </ServiceTabImage>
                      </ServiceTabBackground>
                      <ServiceTabTextWrapper>
                        <ServiceTabTitle>{tab.title}</ServiceTabTitle>
                        <ServiceTabText>
                          {windowWidth <= 1260 ? tab.mobileDescription : tab.description}
                        </ServiceTabText>
                      </ServiceTabTextWrapper>
                    </ServiceCardInner>
                  </ServiceTabContent>
                ))}
              </ServiceCardContainer>
              <PageIndicator className="page-indicator">
                {filteredTabs.map((_, index) => (
                  <IndicatorDot 
                    key={index} 
                    active={activeTab === index}
                    onClick={() => handleTabClick(index)}
                    className={`indicator-dot ${activeTab === index ? 'active' : ''}`}
                  />
                ))}
              </PageIndicator>
            </ServiceCardSlider>
          </ServiceContent>
        </ServiceSection>
      </CenterContainer>
      
      <CenterContainer>
        <WorksSection>
          <WorksHeader>
            <WorksHeaderLeft>
              <WorksTitle>Works</WorksTitle>
              <WorksDescription>다양한 브랜드들과 성공 사례를 만들고 있습니다.</WorksDescription>
            </WorksHeaderLeft>
            <ViewMoreButton className="pc-only">
              <Link to="/works">
                View More
              </Link>
            </ViewMoreButton>
          </WorksHeader>
          <WorksCarousel className="works-carousel" ref={worksCarouselRef}>
            <div 
              className="carousel-container"
              onMouseDown={handleWorksMouseDown}
              onMouseUp={handleWorksMouseUp}
              onMouseLeave={handleWorksMouseUp}
              onMouseMove={handleWorksMouseMove}
              onTouchStart={handleWorksTouchStart}
              onTouchMove={handleWorksTouchMove}
              onTouchEnd={handleWorksTouchEnd}
              onDragStart={preventDragHandler}
            >
              {/* Pre-duplicated set */}
              {homeWorksData.map(work => (
                <WorksCard 
                  key={`pre-${work.id}`} 
                  onClick={() => handleCardClick(work.url)} 
                  onMouseEnter={() => handleWorksCardHover(work)}
                  className="works-card" 
                  onDragStart={preventDragHandler}
                >
                  <WorksCardImage>
                    <img src={work.image} alt={work.title} onDragStart={preventDragHandler} />
                  </WorksCardImage>
                  <WorksCardContent>
                    <WorksCardTitle>{work.title}</WorksCardTitle>
                    <WorksCardTags>
                      {work.tags.map((tag, index) => (
                        <WorksCardTag key={`pre-tag-${index}`}>
                          {tag}
                        </WorksCardTag>
                      ))}
                    </WorksCardTags>
                  </WorksCardContent>
                </WorksCard>
              ))}
              
              {/* Original set */}
              {homeWorksData.map(work => (
                <WorksCard 
                  key={work.id} 
                  onClick={() => handleCardClick(work.url)} 
                  onMouseEnter={() => handleWorksCardHover(work)}
                  className="works-card" 
                  onDragStart={preventDragHandler}
                >
                  <WorksCardImage>
                    <img src={work.image} alt={work.title} onDragStart={preventDragHandler} />
                  </WorksCardImage>
                  <WorksCardContent>
                    <WorksCardTitle>{work.title}</WorksCardTitle>
                    <WorksCardTags>
                      {work.tags.map((tag, index) => (
                        <WorksCardTag key={index}>
                          {tag}
                        </WorksCardTag>
                      ))}
                    </WorksCardTags>
                  </WorksCardContent>
                </WorksCard>
              ))}
              
              {/* Duplicate sets */}
              {homeWorksData.map(work => (
                <WorksCard 
                  key={`duplicate-${work.id}`} 
                  onClick={() => handleCardClick(work.url)} 
                  onMouseEnter={() => handleWorksCardHover(work)}
                  className="works-card" 
                  onDragStart={preventDragHandler}
                >
                  <WorksCardImage>
                    <img src={work.image} alt={work.title} onDragStart={preventDragHandler} />
                  </WorksCardImage>
                  <WorksCardContent>
                    <WorksCardTitle>{work.title}</WorksCardTitle>
                    <WorksCardTags>
                      {work.tags.map((tag, index) => (
                        <WorksCardTag key={`duplicate-${index}`}>
                          {tag}
                        </WorksCardTag>
                      ))}
                    </WorksCardTags>
                  </WorksCardContent>
                </WorksCard>
              ))}
              
              {/* Additional sets */}
              {homeWorksData.map(work => (
                <WorksCard 
                  key={`triplicate-${work.id}`} 
                  onClick={() => handleCardClick(work.url)} 
                  onMouseEnter={() => handleWorksCardHover(work)}
                  className="works-card" 
                  onDragStart={preventDragHandler}
                >
                  <WorksCardImage>
                    <img src={work.image} alt={work.title} onDragStart={preventDragHandler} />
                  </WorksCardImage>
                  <WorksCardContent>
                    <WorksCardTitle>{work.title}</WorksCardTitle>
                    <WorksCardTags>
                      {work.tags.map((tag, index) => (
                        <WorksCardTag key={`triplicate-${index}`}>
                          {tag}
                        </WorksCardTag>
                      ))}
                    </WorksCardTags>
                  </WorksCardContent>
                </WorksCard>
              ))}
              
              {homeWorksData.map(work => (
                <WorksCard 
                  key={`quadruplicate-${work.id}`} 
                  onClick={() => handleCardClick(work.url)} 
                  onMouseEnter={() => handleWorksCardHover(work)}
                  className="works-card" 
                  onDragStart={preventDragHandler}
                >
                  <WorksCardImage>
                    <img src={work.image} alt={work.title} onDragStart={preventDragHandler} />
                  </WorksCardImage>
                  <WorksCardContent>
                    <WorksCardTitle>{work.title}</WorksCardTitle>
                    <WorksCardTags>
                      {work.tags.map((tag, index) => (
                        <WorksCardTag key={`quadruplicate-${index}`}>
                          {tag}
                        </WorksCardTag>
                      ))}
                    </WorksCardTags>
                  </WorksCardContent>
                </WorksCard>
              ))}
              
              {/* Post-duplicated set */}
              {homeWorksData.map(work => (
                <WorksCard 
                  key={`post-${work.id}`} 
                  onClick={() => handleCardClick(work.url)} 
                  onMouseEnter={() => handleWorksCardHover(work)}
                  className="works-card" 
                  onDragStart={preventDragHandler}
                >
                  <WorksCardImage>
                    <img src={work.image} alt={work.title} onDragStart={preventDragHandler} />
                  </WorksCardImage>
                  <WorksCardContent>
                    <WorksCardTitle>{work.title}</WorksCardTitle>
                    <WorksCardTags>
                      {work.tags.map((tag, index) => (
                        <WorksCardTag key={`post-tag-${index}`}>
                          {tag}
                        </WorksCardTag>
                      ))}
                    </WorksCardTags>
                  </WorksCardContent>
                </WorksCard>
              ))}
            </div>
          </WorksCarousel>
          
          <ViewMoreButton className="mobile-only">
            <Link to="/works">
              View More
            </Link>
          </ViewMoreButton>
        </WorksSection>
      </CenterContainer>
      
      <CenterContainer>
        <PowerSection>
          <PowerHeader>
            <PowerTitle>Power</PowerTitle>
            <PowerDescription>다양한 글로벌 플랫폼과 함께하여 브랜드 목적에 맞는 캠페인 운영이 가능합니다.</PowerDescription>
          </PowerHeader>
          <PowerContent>
            <PowerStatsRow>
              {powerStats.map((stat, index) => {
                const { value, ref } = useNumberAnimation(stat.number);
                return (
                  <PowerStatCard key={stat.id} bgColor={stat.bgColor} ref={ref}>
                    <PowerStatImage 
                      src={stat.image} 
                      alt={stat.label} 
                      style={{ 
                        width: stat.imageWidth, 
                        height: stat.imageHeight,
                        opacity: 0.3,
                        filter: index === 2 ? 'brightness(0) invert(0.9)' : 'none'
                      }} 
                    />
                    <PowerStatContent>
                      <PowerNumber>{value}+</PowerNumber>
                      <PowerLabel>{stat.label}</PowerLabel>
                    </PowerStatContent>
                  </PowerStatCard>
                );
              })}
            </PowerStatsRow>
            <PowerPartnersRow>
              {powerPartners.map(partner => (
                <PowerPartnerCard key={partner.id}>
                  <PowerPartnerLogo 
                    src={window.innerWidth <= 480 && partner.mobileLogo ? partner.mobileLogo : partner.logo} 
                    alt={partner.label} 
                    partnerId={partner.id}
                  />
                  <PowerPartnerLabel partnerId={partner.id}>{partner.label}</PowerPartnerLabel>
                </PowerPartnerCard>
              ))}
            </PowerPartnersRow>
          </PowerContent>
        </PowerSection>
      </CenterContainer>
        
      <TrustSection className="trust-section">
        <CenterContainer>
          <TrustHeader>
            <TrustTitle>Trust</TrustTitle>
            <TrustDescription>다양한 서비스의 브랜드들과 좋은 성공사례를 만들고 있습니다.</TrustDescription>
          </TrustHeader>
          
          <TrustCarousel ref={trustCarouselRef}>
            <div 
              className="trust-roll-container"
              onMouseDown={handleTrustMouseDown}
              onMouseUp={handleTrustMouseUp}
              onMouseLeave={handleTrustMouseUp}
              onMouseMove={handleTrustMouseMove}
              onTouchStart={handleTrustTouchStart}
              onTouchMove={handleTrustTouchMove}
              onTouchEnd={handleTrustTouchEnd}
              onDragStart={preventDragHandler}
            >
              {/* Pre-duplicated set for leftward scrolling */}
              {trustTestimonials.map(testimonial => (
                <TrustCard 
                  key={`pre-${testimonial.id}`}
                  className="trust-card"
                  onClick={handleTrustCardClick}
                >
                  <TrustCardLogo 
                    src={testimonial.logoUrl} 
                    alt="Client Logo" 
                    className="larger-logo"
                    loading="lazy"
                  />
                  <TrustCardQuote>{testimonial.content}</TrustCardQuote>
                  <TrustCardAuthor>{`- ${testimonial.contactPerson}`}</TrustCardAuthor>
                </TrustCard>
              ))}
              
              {/* 첫 번째 세트 */}
              {trustTestimonials.map(testimonial => (
                <TrustCard
                  key={`original-${testimonial.id}`}
                  className="trust-card"
                  onClick={handleTrustCardClick}
                >
                  <TrustCardLogo 
                    src={testimonial.logoUrl} 
                    alt="Client Logo" 
                    className="larger-logo"
                    loading="lazy"
                  />
                  <TrustCardQuote>{testimonial.content}</TrustCardQuote>
                  <TrustCardAuthor>{`- ${testimonial.contactPerson}`}</TrustCardAuthor>
                </TrustCard>
              ))}
              
              {/* 두 번째 세트 (무한 롤링을 위한 정확한 복제) */}
              {trustTestimonials.map(testimonial => (
                <TrustCard 
                  key={`duplicate-${testimonial.id}`}
                  className="trust-card"
                  onClick={handleTrustCardClick}
                >
                  <TrustCardLogo 
                    src={testimonial.logoUrl} 
                    alt="Client Logo" 
                    className="larger-logo"
                    loading="lazy"
                  />
                  <TrustCardQuote>{testimonial.content}</TrustCardQuote>
                  <TrustCardAuthor>{`- ${testimonial.contactPerson}`}</TrustCardAuthor>
                </TrustCard>
              ))}
              
              {/* 추가 세트 - 확실한 연속 스크롤을 위해 */}
              {trustTestimonials.map(testimonial => (
                <TrustCard 
                  key={`triplicate-${testimonial.id}`}
                  className="trust-card"
                  onClick={handleTrustCardClick}
                >
                  <TrustCardLogo 
                    src={testimonial.logoUrl} 
                    alt="Client Logo" 
                    className="larger-logo"
                    loading="lazy"
                  />
                  <TrustCardQuote>{testimonial.content}</TrustCardQuote>
                  <TrustCardAuthor>{`- ${testimonial.contactPerson}`}</TrustCardAuthor>
                </TrustCard>
              ))}
            </div>
          </TrustCarousel>
        </CenterContainer>
      </TrustSection>
    </HomeRoot>
  );
};

export default Home;